export default __webpack_public_path__ + "static/media/logo.c0d7c2f7.png";